import { useNavigate } from 'react-router-dom'

function NoAccess() {
    const navigate = useNavigate()

    return (
        <main>
            <div>NoAccess</div>
            <button onClick={() => navigate('/')}>Back to home page</button>
        </main>
    )
}

export default NoAccess
